<template>
  <div>
    <button class="hero-button" @click="openCalendly">
        {{ signedIn ? "Contact Us" : "Schedule a Demo" }}
    </button>
  </div>
</template>

<script>
export default {
    props: {
    signedIn: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Load Calendly CSS
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Load Calendly JS
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  },
  methods: {
    openCalendly(event) {
      event.preventDefault(); // Prevent default link behavior
      if (window.Calendly) {
        window.Calendly.initPopupWidget({ url: "https://calendly.com/vibe-tap" });
      } else {
        console.error("Calendly script not loaded yet");
      }
    }
  }
};
</script>
<style scoped>
.hero-button {
  background-color: black;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
</style>